import { CourseConfig } from '../../../configs/stream-entities';

class CourseDetailState extends CourseConfig {
    public selectedId: string;
    public courseName: string;
}

export default CourseDetailState


// WEBPACK FOOTER //
// ./src/components/schedule/course-detail/CourseDetailState.ts